/**
 * Transform an API Purchaser object to a Purchaser
 *
 * @param purchaser The API Purchaser object
 * @returns Purchaser
 */
export function transformPurchaser(purchaser: ApiSchema['Booking']['purchaser']): Purchaser {
    return {
        gender: purchaser?.gender,
        firstName: purchaser?.detail?.firstName ?? '',
        lastName: purchaser?.detail?.lastName ?? '',
        email: purchaser?.detail?.email ?? '',
        phoneNumber: purchaser?.detail?.phoneNumber ?? undefined,
        address: {
            street: purchaser?.detail?.address?.street ?? '',
            postCode: purchaser?.detail?.address?.postCode ?? '',
            city: purchaser?.detail?.address?.city ?? '',
            countryCode: purchaser?.detail?.address?.countryCode ?? '',
        },
    };
}
